import { resolveEffectiveTheme } from './resolve-effective-theme.js';
import { useThemePreference } from './theme-preference-storage.js';
import type { ThemeId } from './theme-meta.js';
import { useSystemPrefersDark } from './use-system-prefers-dark.js';

/**
 * FR-07 - efektivní šablona, i pro místa, která podle motivu vybírají variantu assetu (např. tmavé
 * logo, FR-14). Platí stejně na aplikačním i marketingovém hostu - landing page má vlastní přepínač
 * Světlý/Tmavý (dřívější výjimka "vždy Light" z PART1 FR-09 je zrušená), stejně jako `theme-init.js`.
 */
export function useEffectiveTheme(): ThemeId {
  const preference = useThemePreference();
  const systemPrefersDark = useSystemPrefersDark();
  return resolveEffectiveTheme(preference, systemPrefersDark);
}
